<template>
  <section class="containerMaintenance">
    <p class="containerMaintenance__link" @click="goToHome">{{linkTitle}}</p>
    <picture>
      <img class="containerMaintenance__img" src="../../assets/under_maintenance.gif" />
    </picture>
    <h1 class="containerMaintenance__title">{{texts.title}}</h1>
    <p class="containerMaintenance__subtitle">{{texts.subtitle}}</p>
  </section>
</template>

<script>
import { texts } from './maintenance.json'
export default {
  name: 'maintenance',
  props: ['linkTitle'],
  data () {
    return {
      texts: texts
    }
  },
  methods: {
    /**
     * @description Go to home page
     */
    goToHome () {
      window.location.href = '/'
    }
  }
}
</script>
